import { Col, Row } from "react-bootstrap";
import MaterialIcon, {
  MtIcon,
} from "../../oversight-core/ui-elements/material-icon/material-icon";
import SpinnerModal from "../../oversight-core/ui-elements/spinner/spinner";
import styles from "./site-status-count.module.scss";

interface IProps {
  count: number;
  title: string;
  onClick: () => void;
  iconColor: string;
  isLoading?: boolean;
  icon: MtIcon;
  selected?: boolean;
}

const SiteStatusCount = (props: IProps) => {
  const { count, title, onClick, iconColor, isLoading, icon, selected } = props;
  return (
    <div
      className={`${
        selected ? styles.selectedCardContainer : styles.cardContainer
      } p-2 cursor-pointer h-100`}
      onClick={onClick}
    >
      <Row className="align-items-center row-cols-auto gx-2">
        <Col className="">
          <MaterialIcon icon={icon} color={iconColor} weight={500} size={18} />
        </Col>
        <Col className="text-dark font-weight-600 font-size-16">
          {isLoading ? (
            <SpinnerModal show={isLoading} withOverlay={false} size="sm" />
          ) : (
            <>{count}</>
          )}
        </Col>
        <Col
          className={`${styles.title} text-light font-weight-400 font-size-12`}
        >
          {title}
        </Col>
      </Row>
    </div>
  );
};

export default SiteStatusCount;
